import { render } from "./IpInfoComponent.vue?vue&type=template&id=3d640c82"
import script from "./IpInfoComponent.vue?vue&type=script&lang=js"
export * from "./IpInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__